import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './access/login/login.component';
import { MainComponent } from './main/main.component';
import { ResourcesViewCalendarComponent } from './resources-view-calendar/resources-view-calendar.component';
import { RedirectEventComponent } from './redirect-event/redirect-event.component';
import { AuthGuard } from './services/auth.guard';




const routes: Routes = [ { path: '',redirectTo:'login', pathMatch: "full" },
{path:'login', component:LoginComponent, pathMatch: "full"},
{path:'login/gts/:param', component:LoginComponent, pathMatch: "full"},
{path:'login/:param', component:LoginComponent, pathMatch: "full"},
//{path:'login/client/:param/:client', component:LoginComponent, pathMatch: "full"},
//{path:'login/client/:param/:client/:idDetail', component:LoginComponent, pathMatch: "full"},
//{path:'login/client/:param/:client/:idDetail', component:LoginComponent, pathMatch: "full"},
{path:'login/:param/:calendarDetail', component:LoginComponent, pathMatch: "full"},
{path:'login/gts/:param/:calendarDetail', component:LoginComponent, pathMatch: "full"},
//{path:'login/detail/:param/:idDetail', component:LoginComponent, pathMatch: "full"},
{path:'main', component: MainComponent, pathMatch: "full", canActivate: [AuthGuard]},
{path:'event/:id', component: RedirectEventComponent, pathMatch: 'full'},
{path:'resources/:id/:name',component:ResourcesViewCalendarComponent, pathMatch:"full", canActivate: [AuthGuard]},
{path:'resources/:id/:name/:user',component:ResourcesViewCalendarComponent, pathMatch:"full", canActivate: [AuthGuard]},
//{path:'panel/:id', component:PanelComponent, pathMatch:"full"},

//{path: 'panel/:id/:query',component: PanelComponent, pathMatch:"full"},
/*{path: 'panel/:id/:query', component: PanelComponent,
    children: [
        {
            path: 'workplaces',
            component: WorkplaceSchedulesComponent,
            }
      
      ]},*/
//{path: 'panel', component:PanelComponent, loadChildren:()=>PanelModule},
{path: 'panel/:id', loadChildren:()=>import('./panel/panel.module').then (x=>x.PanelModule), canActivate: [AuthGuard] },
//{path: 'panel/:id', loadChildren:()=>import('./panel/panel.module').then (x=>x.PanelModule) },
//{path: 'panel/:id/:query', loadChildren:()=>import('./panel/panel.module').then (x=>x.PanelModule) },
{ path: '**', component: LoginComponent }];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})


export class AppRoutingModule { 
}
